import { render, staticRenderFns } from "./RoleManagementOneDialog.vue?vue&type=template&id=b0002e22&scoped=true&"
import script from "./RoleManagementOneDialog.vue?vue&type=script&lang=js&"
export * from "./RoleManagementOneDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagementOneDialog.vue?vue&type=style&index=0&id=b0002e22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0002e22",
  null
  
)

export default component.exports